module.exports = __webpack_public_path__ + "img/arrow_right_grey.23718dce.svg";